import { IDropdownOptions } from '../../models';
import { SET_GF_TIMESHEET_STATUSES, SET_WEEK } from '../actions/timesheet';

export interface ITimesheetState {
  week: {
    start: string;
    end: string;
    number: number;
  } | null;
  timesheetStatuses: IDropdownOptions[];
}
export const getInitialState = () => ({
  week: null,
  timesheetStatuses: [],
});

const timesheetReducer = (state: ITimesheetState = getInitialState(), action: any) => {
  switch (action.type) {
    case SET_WEEK:
      return {
        ...state,
        week: action.payload,
      };
    case SET_GF_TIMESHEET_STATUSES:
      return {
        ...state,
        timesheetStatuses: action.payload,
      };

    default:
      return state;
  }
};

export default timesheetReducer;
